export const ENDPOINTS = {
  get_agenda: "agenda/",
};
